import { BridgewayGlyph } from './BridgewayGlyph';

type Props = { label?: string; delayMs?: number };

export const LoadingInterstitial = ({
	label = 'Project Bridgeway',
	delayMs = 250, // Short delay to avoid flashing
}: Props) => (
	<div
		className="flex h-full min-h-screen w-full items-center justify-center"
		role="status"
		aria-label={label}
	>
		<div
			className="loading-interstitial-content loading-interstitial-fade-in flex
				flex-col items-center gap-1"
			style={{ animationDelay: `${Math.max(0, delayMs)}ms` }}
		>
			<BridgewayGlyph />
			<p
				className="font-adobe-clean-display text-[18px] leading-[26px]
					font-black"
			>
				{label}
			</p>
		</div>
	</div>
);
